var $717402cc972c0e9e$exports = {};
$717402cc972c0e9e$exports = {
    "backButton": (args)=>`Zur\xfcck zu ${args.prevMenuButton}`,
    "moreActions": `Mehr Aktionen`,
    "unavailable": `Nicht verf\xfcgbar, f\xfcr Details erweitern`
};


export {$717402cc972c0e9e$exports as default};
//# sourceMappingURL=de-DE.mjs.map
